import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasSession, serverAuth } from "@/data/auth";
import { JoinPage } from "@/features/join/JoinPage";

/** Join a workspace (L11): where a signed-in account with no workspace lands. Sits outside the _app layout, so there is no
 *  app shell, like the other public pages. */
export const Route = createFileRoute("/join")({
  // server mode: a signed-out visitor goes to sign in instead of the error state (X16-S203)
  beforeLoad: async () => {
    if (!serverAuth || (await hasSession()) !== false) return;
    throw redirect({ to: "/sign-in", search: {} });
  },
  component: JoinPage,
});
